const Permissions = () => import("Core/configuration/permissions/views/Permissions");
const PermissionTemplates = () => import("Core/configuration/permissions/views/PermissionTemplates");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "configuration/permissions",
            name: "settings_permissions",
            component: Permissions,
            meta: {
                requiresAuth: true,
                title: "lang.permissions",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "configuration/permission_templates/:id?",
            name: "settings_permission_templates",
            component: PermissionTemplates,
            meta: {
                requiresAuth: true,
                title: "lang.permission_templates",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
